import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center gap-3"
}
const _hoisted_2 = { class: "d-flex align-items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-nowrap" }, "Hiển thị", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-nowrap" }, "bản ghi/trang", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "d-flex align-items-center gap-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Trang", -1)
const _hoisted_8 = { class: "fw-semibold" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_QuantityInputCustom = _resolveComponent("QuantityInputCustom")!
  const _component_PdfViewerPage = _resolveComponent("PdfViewerPage")!

  return (_openBlock(), _createBlock(_component_PdfViewerPage, {
    title: _ctx.pageTitle,
    source: _ctx.pdfSource,
    "file-name": _ctx.pdfFileName,
    loading: _ctx.isGenerating,
    "loading-message": _ctx.loadingMessage
  }, {
    "header-right": _withCtx(() => [
      (_ctx.pagination)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_el_select, {
                modelValue: _ctx.perPageInput,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.perPageInput) = $event)),
                class: "bao-cao-viewer__per-page-select",
                disabled: _ctx.isGenerating,
                onChange: _ctx.onPerPageChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.perPageOptions, (size) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: size,
                      label: String(size),
                      value: size
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "onChange"]),
              _hoisted_4
            ]),
            (_ctx.pagination.lastPage > 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-light-secondary",
                    disabled: _ctx.isGenerating || _ctx.pagination.currentPage <= 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.pagination.currentPage - 1)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "arrow-left",
                      class: "me-1"
                    }),
                    _createTextVNode(" Trang trước ")
                  ], 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_QuantityInputCustom, {
                      modelValue: _ctx.pageInput,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageInput) = $event)),
                      "class-str": "bao-cao-viewer__page-input",
                      min: 1,
                      max: _ctx.pagination.lastPage,
                      "is-disabled": _ctx.isGenerating,
                      onChange: _ctx.onPageInputChange
                    }, null, 8, ["modelValue", "max", "is-disabled", "onChange"]),
                    _createElementVNode("span", _hoisted_8, "/ " + _toDisplayString(_ctx.pagination.lastPage), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-light-secondary",
                    disabled: 
              _ctx.isGenerating || _ctx.pagination.currentPage >= _ctx.pagination.lastPage
            ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.pagination.currentPage + 1)))
                  }, [
                    _createTextVNode(" Trang sau "),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "arrow-right",
                      class: "ms-1"
                    })
                  ], 8, _hoisted_9)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "printArea",
        class: "bao-cao-viewer__hidden-template",
        style: _normalizeStyle(_ctx.hiddenTemplateStyle),
        "aria-hidden": "true"
      }, [
        (_ctx.templateComponent)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle(_ctx.printPaperStyle)
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.templateComponent), _normalizeProps(_guardReactiveProps(_ctx.templateProps)), null, 16))
            ], 4))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["title", "source", "file-name", "loading", "loading-message"]))
}